<!-- 登陆页 -->

<template>
  <div class="page login-page as-flex main-center cross-center">
    <div class="login-box as-flex flex-vertical main-start cross-center">
      <swiper :options="swiperOption" ref="mySwiper" class="login-box-content">
        <swiper-slide key="login">
          <div class="login-box-content as-flex flex-vertical main-start cross-center">
            <div class="logo as-flex">
              <img src="../assets/images/login-logo.png" width="100%" height="100%" />
            </div>
            <!-- <div class="title f-3">众观智影</div> -->
            <div class="username as-flex main-center">
              <i class="icon icon-user"></i>
              <!-- <i class="icon icon-delete" @click="deleteUsername"></i> -->
              <input type="text" v-model="username" />
            </div>
            <div class="password as-flex main-center">
              <i class="icon icon-lock"></i>
              <input class type="password" v-model="password" />
            </div>
            <div class="function-box as-flex main-between cross-center f-2">
              <div class="fucntion-left as-flex main-start cross-center">
                <input id="rememberme" v-model="rememberMe" type="checkbox" class="checkbox" />
                <label for="rememberme">记住我</label>
              </div>
              <div class="fucntion-right as-flex main-center cross-center" @click="forgetPassword">
                <span>忘记密码</span>
                <div class="login-go-right">
                  <i class="icon icon-login-right"></i>
                </div>
              </div>
            </div>
            <div class="error f-1 fc-red">{{error||""}}</div>
            <div
              class="button as-circle login-btn f-3 fc-white as-flex main-center cross-center"
              @click="login"
            >登 录</div>
          </div>
        </swiper-slide>
        <swiper-slide key="passwordOperation">
          <div class="login-box-content as-flex flex-vertical main-start cross-center">
            <passwordOperation
              class="as-modal"
              @close="changeLoginStatus(false)"
              :defaultConfig="defaultPasswordConfig"
            ></passwordOperation>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="contact-us f-1 as-flex main-center cross-center">
      <a href="https://www.fanink.cn/callus">联系我们</a>
    </div>
  </div>
</template>

<script>
const LOGIN_ERROR = {
  USERNAME_FORMAT_ERROR: "账号或密码格式错误",
  PASSWORD_USERNAME_ERROR: "账号或密码错误",
  AUTHORIZATION_TIMEOUT_ERROR: "此账号无使用权限",
  NETWORK_ERROR: "网络异常，请检查后重试",
  UNKNOWN_ERROR: "未知错误"
};
import storageUtil from "../utils/storage/base";
import passwordOperation from "../components/common/passwordOperation";

export default {
  data() {
    return {
      LOGIN_ERROR: LOGIN_ERROR,
      username: "",
      password: "",
      error: undefined,
      rememberMe: false,
      loginForget: false,
      defaultPasswordConfig: {},
      swiperOption: {
        allowTouchMove: false,
        autoplay: false
      }
    };
  },
  props: {},
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  components: {
    passwordOperation: passwordOperation
  },
  methods: {
    changeSlider(index) {
      this.swiper.slideTo(index, 500, false);
    },
    clickEnter(e) {
      // 兼容FF和IE和Opera
      let event = e || window.event;
      let key = event.which || event.keyCode || event.charCode;
      if (key === 13) {
        /*Do something. 调用一些方法*/
        this.login();
      }
    },
    async login() {
      this.$route.query.redirect = "/index";
      // this.error = LOGIN_ERROR.USERNAME_FORMAT_ERROR;
      let res = await this.$store.dispatch("user/login", {
        name: this.username,
        password: this.password
      });
      if (res.status === true) {
        this.error = undefined;
        await this.$store.dispatch("user/updateUserInfo");
        if (this.rememberMe) {
          this.recordPassword();
        } else {
          this.deleteRecordIfNeeded();
        }
      } else {
        this.error = LOGIN_ERROR[res.msg];
      }
    },
    forgetPassword() {
      this.defaultPasswordConfig.type = "reset";
      this.changeLoginStatus(true);
    },
    changeLoginStatus(value) {
      let index = value ? 1 : 0;
      this.changeSlider(index);
      this.error = undefined;
    },
    deleteUsername() {
      this.username = "";
    },
    recordPassword() {
      //搜索记录字段名为 'history'
      let structure = {};
      structure[this.username] = this.password;
      //判断当前有无记录的密码
      let historystructureExist = storageUtil.getStorage("password").status;
      if (!historystructureExist) {
        //没有记录
        storageUtil.addStorage("password", structure);
      } else {
        storageUtil.updateStorage("password", structure);
      }
    },
    deleteRecordIfNeeded() {
      let structure = storageUtil.getStorage("password").msg;
      if (structure && structure[this.username]) {
        delete structure[this.username];
      }
      storageUtil.updateStorage("password", structure);
    }
  },
  async created() {
    //记住密码后，进入页面反现账号密码
    let structure = storageUtil.getStorage("password").msg;
    if (structure && Object.entries(structure).length > 0) {
      //有记录
      this.username = Object.entries(structure)[0][0];
      this.password = Object.entries(structure)[0][1];
      this.rememberMe = true;
    }
    // await this.$store.dispatch("user/updateUserInfo");
    //bind keyboard click event
    window.addEventListener("keyup", this.clickEnter);
  },
  async mounted() {
    await this.$store.dispatch("user/updateUserInfo");
    if (!this.$store.getters["user/isLogined"]) {
      //登出之前，将 首页/影片库 页面的记录删除---
      let delArr = [];
      let tabs = this.$store.getters["tabpage/getTabPages"];
      tabs.forEach(item => {
        if (["index", "movieLib"].includes(item.type)) {
          delArr.push(item.statusCode);
        }
      });
      this.$store.commit("tabpage/closeMultiTab", { statusCodeArr: delArr });
      //------------------------------------
    }
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.clickEnter);
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.login-page {
  position: relative;
  z-index: 0;
  height: 100vh;
  width: 100vw;
  // min-height: 10rem;
  background-color: #efefef;
  //背景渐变
  // background: -webkit-linear-gradient(#62bcfb, #038dd7); /* Safari 5.1 - 6.0 */
  // background: -o-linear-gradient(#62bcfb, #038dd7); /* Opera 11.1 - 12.0 */
  // background: -moz-linear-gradient(#62bcfb, #038dd7); /* Firefox 3.6 - 15 */
  // background: linear-gradient(
  //   #62bcfb,
  //   #038dd7
  // ); /* 标准的语法（必须放在最后） */
  background-image: url(../assets/images/login-bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 0 0;
}
.login-box {
  overflow: hidden;
  width: 350px;
  height: 400px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 0px 1.5px 1.5px #fff;
  .logo {
    width: 40%;
    height: 30%;
    margin: 20px 0 10px 0;
  }
  .title {
  }
  .username {
    position: relative;
    width: 75%;
    // height: 2em;
    margin: 1em;
  }
  .password {
    position: relative;
    width: 75%;
    // height: 2em;
    margin: 1em;
  }
  .login-box-content {
    width: 100%;
    height: 100%;
  }
  .fucntion-left {
    margin-left: 5px;
    cursor: pointer;
    &:hover {
      color: #76c2f8;
    }
  }
  .fucntion-right {
    margin-right: 5px;
    .login-go-right {
      position: absolute;
      right: 1px;
      width: 18px;
      height: 18px;
      margin: 0 3px;
    }
    &:hover {
      color: #76c2f8;
    }
    cursor: pointer;
  }
}

.function-box {
  position: relative;
  color: #61b6e6;
  height: 1.5em;
  width: 250px;
  padding: 0 20px;
}
.error {
  color: #f2651d;
  margin: 10px;
}
.login-btn {
  width: 250px;
  height: 2.5em;
  border: none;
  background-color: #61b6e6;
}
.checkbox {
  position: relative;
  padding: 0;
  width: 10px;
  height: 10px;
}

.contact-us {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  width: 100%;
  // height: 1rem;
  color: white;
  &.as-pc {
    position: relative;
  }
}
.as-modal {
  z-index: 999;
}
a {
  color: white;
  text-decoration-line: none;
  -moz-text-decoration-style: none;
}

input {
  outline: none;
  height: 3em;
  width: 250px;
  color: black;
  border: 1px solid #b9b9b9;
  border-radius: 20px;
  padding: 5px 40px;
  background-color: #fff;
  &:hover {
    border: 1px solid #61b6e6;
  }
  &:focus {
    border: 1px solid #128fd8;
  }
}
input[type="checkbox"] {
  display: none;
  color: black;
}
input[type="checkbox"] + label::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 5px;
  transform: translateY(-50%);
  width: 15px;
  height: 15px;
  padding: 2px;
  margin-right: 5px;
  // background-clip: content-box;
  background-size: 100% !important;
  background-repeat: no-repeat;
  background: url(../assets/images/rememberme-not-active.png);
}
input[type="checkbox"]:checked + label::before {
  background: url(../assets/images/rememberme-active.png);
}
</style>

